import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { Button } from '@/components/ButtonComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useCoreNavigation } from '@/navigation/navigation';
import { SEPARATOR_HEIGHT } from '@/styles/styles';

export const GuestLoginButtons = () => {
    const navigation = useNavigation();
    const { t } = useTranslation('common');
    const goToRoute = useCallback(
        (route: 'Login' | 'Register') => {
            navigation.reset({
                routes: [{ name: 'Launch' }, { name: route }],
            });
        },
        [navigation]
    );
    return (
        <Row p={'s16'} style={styles.root}>
            <Button
                flex={1}
                variant={'emphasis'}
                label={t('sign_up')}
                hierarchy={'primary'}
                onPress={() => {
                    goToRoute('Register');
                }}
            />
            <Box width={12} />
            <Button
                testID="guestLoginButton"
                flex={1}
                label={t('login')}
                onPress={() => {
                    goToRoute('Login');
                }}
            />
        </Row>
    );
};

export const GuestLoginBanner = () => {
    const { openLaunch } = useCoreNavigation();
    const { t } = useTranslation('common');

    return (
        <Button
            label={`${t('login')}/${t('sign_up')}`}
            hierarchy={'primary'}
            variant={'emphasis'}
            style={styles.button}
            textStyle={styles.buttonText}
            onPress={() => {
                openLaunch();
            }}
        />
    );
};

const styles = StyleSheet.create({
    root: {
        backgroundColor: ds.colorValue.background.neutral.base,
        borderTopWidth: SEPARATOR_HEIGHT,
        borderTopColor: ds.colorValue.border.strong,
    },
    button: {
        backgroundColor: ds.colorValue.background.brand.emphasis,
    },
    buttonText: {
        color: ds.colorValue.text.primary,
        fontSize: 16,
    },
});
